import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  if (to.matched.length === 0) {
    console.log('(stop@appointmentLandingPage) no route matched')
    // @todo maybe introduce a global 404 page instead of 'appointmentLandingPage'?

    const appointmentId = window.location.pathname.split('/')[1]
    return navigateTo({
      name: 'appointmentId',
      params: {
        appointmentId
      }
    })
  }

  console.log('(next) passthrough')
})
